import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaClock, FaFlask, FaCalendarAlt, FaArrowRight, FaFire, FaStar } from "react-icons/fa";

const SalesPackageSection = ({ currentPackage, t, i18n }) => {
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState("");
  const [index, setIndex] = useState(0);
  const isArabic = i18n.language === 'ar';
  const navigate = useNavigate();

  // Keep your original image selection logic
  const imageSale = Array.isArray(
    currentPackage && isArabic ? currentPackage.image_ar : currentPackage.image_en
  ) ? (currentPackage && isArabic ? currentPackage.image_ar : currentPackage.image_en) : [];

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (imageSale.length > 1) {
      const slideTimer = setInterval(() => {
        setIndex((prevIndex) => (prevIndex + 1) % imageSale.length);
      }, 4000);
      return () => clearInterval(slideTimer);
    }
  }, [imageSale.length]);

  useEffect(() => {
    if (currentPackage && currentPackage.endDate) {
      const endDate = new Date(currentPackage.endDate);
      const today = new Date();
      const timeDiff = endDate - today;

      if (timeDiff > 0) {
        const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24) + 1);
        setTimeLeft(`${daysLeft} ${t("days")}`);
      } else {
        setTimeLeft(t("expired"));
      }
    }
  }, [currentPackage, t]);

  if (loading || !currentPackage) {
    return (
      <div className="w-full max-w-sm h-96 bg-gray-100 animate-pulse rounded-3xl" />
    );
  }

  // Preserve your dynamic naming logic
  const packageName = isArabic ? currentPackage.name_ar : currentPackage.name_en;
  const packageDescription = isArabic ? currentPackage.description_ar : currentPackage.description_en;
  const packageImage = isArabic ? currentPackage.image_ar : currentPackage.image_en;

  return (
    <div className="relative w-full max-w-sm group">
      <div className="bg-white rounded-[2rem] shadow-2xl overflow-hidden border border-gray-100 transition-all duration-500 hover:-translate-y-2">
        
        {/* Sale Percent Badge */}
        {currentPackage.salePercent && (
          <div className={`absolute top-5 ${isArabic ? "left-5" : "right-5"} z-30 flex items-center gap-2 bg-red-600 text-white text-xs font-bold rounded-full px-4 py-2 shadow-lg animate-pulse`}>
            <FaFire className="text-yellow-300" />
            <span>{currentPackage.salePercent}% {t("discount") || "OFF"}</span>
          </div>
        )}

        {/* Image Area */}
        <div className="relative h-[40%] overflow-hidden bg-gray-100">
          <img
            src={imageSale[index] || (Array.isArray(packageImage) ? packageImage[0] : packageImage)}
            alt={packageName}
            className="w-full h-full rounded-t-[2rem] object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          
          {/* Glass Badges */}
          <div className={`absolute bottom-4 ${isArabic ? "right-4" : "left-4"} flex gap-2`}>
             <div className="flex items-center gap-1.5 bg-white/90 backdrop-blur-md px-3 py-1.5 rounded-xl text-[11px] font-bold text-gray-800 shadow-sm">
                <FaClock className="text-primeColor-600" /> {currentPackage.offerDuration}
             </div>
             <div className="flex items-center gap-1.5 bg-white/90 backdrop-blur-md px-3 py-1.5 rounded-xl text-[11px] font-bold text-gray-800 shadow-sm">
                <FaFlask className="text-primeColor-600" /> {currentPackage.tests} {t("offer.test")}
             </div>
          </div>

          {timeLeft && (
            <div className={`absolute top-4 ${isArabic ? "right-4" : "left-4"} flex items-center gap-1.5 bg-orange-500 text-white px-3 py-1.5 rounded-xl text-[11px] font-bold shadow-lg`}>
              <FaCalendarAlt /> {timeLeft}
            </div>
          )}
        </div>

        {/* Text Content */}
        <div className="p-4">
          <h3 className="text-2xl font-bold text-gray-900 mb-1 line-clamp-1">{packageName}</h3>
          <p className="text-gray-500 text-sm mb-6 line-clamp-2">{packageDescription}</p>

          <div className="flex items-center  justify-between pt-4 border-t border-gray-100">
            <div className="w-[50%]">
              {/* <p className="text-xs text-gray-400 line-through">
                {Math.round(currentPackage.salePrice / (1 - currentPackage.salePercent / 100))} {t("currency")}
              </p> */}
              <div className="flex items-baseline gap-1 text-primeColor-600">
                <span className="text-4xl font-black">{currentPackage.salePrice}</span>
                <span className="text-xs font-bold uppercase">{t("currency")}</span>
              </div>
            </div>

            <button
              onClick={() => navigate("/package/detail", { state: currentPackage })}
              className="flex items-center text-center w-[50%] gap-2 bg-primeColor-600 text-white px-3 py-3 rounded-2xl font-bold hover:bg-primeColor-700 transition-all shadow-lg hover:shadow-primeColor-200"
            >
              <span className="text-sm">{t("home.landingPage.salesPackage.packageButton")}</span>
              <FaArrowRight className={isArabic ? "rotate-180" : ""} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesPackageSection;